var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tel != '')?_c('div',{staticClass:"session-info-subtitle"},[_c('b',[_vm._v("Tel:")]),_vm._v(" "+_vm._s(_vm.tel))]):_vm._e(),(_vm.cel != '')?_c('div',{staticClass:"session-info-subtitle"},[_c('b',[_vm._v("Cel:")]),_vm._v(" "+_vm._s(_vm.cel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }